import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listabot'
})
export class ListabotPipe implements PipeTransform {

  transform(value: any, usuariosmx: any, idusuario: string ): any {
    const resultPost = [];
    for ( const post of value) {
      if ((post.role == "USER_SPORTFISHING") && (post.enlinea))  {

        if (usuariosmx) {
          if (post._id == idusuario) {
            resultPost.push (post);
          }

        } else {
          resultPost.push (post);
        }

         
      }
    }
    return resultPost;
  }

}
